import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { BackButton, DefaultLoader, FundList } from "../../components";

import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";

import { compose } from "underscore";
import { getFundList, sendFundsCode } from "../fundSelection/redux/action";

import { useIsFirstRender } from "../../utils/hooks";

import "./style.fund-selection.scss";

const RetiredFundSelection = ({
  history,
  getFundList,
  funds,
  fundsLoading,
  sendFundsCode,
}) => {
  const firstRender = useIsFirstRender();

  useEffect(() => {
    getFundList({ category: "MPRetire" });
  }, []);

  const handleSelect = ({
    code,
    name,
    salesFeePerc: salesCharge,
    serviceTaxPerc,
    id,
  }) => () => {
    dataLayerGTM(
      "click_tag",
      "Click",
      "Button",
      `Retirement Fund ${name} - Select`
    );

    sendFundsCode([
      {
        name,
        code,
        salesCharge,
        serviceTaxPerc,
        id, // for productId
      },
    ]);
    history.push("/retirement/cash-in");
  };

  if (firstRender) return null;

  if (fundsLoading) return <DefaultLoader />;

  return (
    <>
      <div
        style={{
          backgroundColor: "#f6f6f8",
          minHeight: "100vh",
          paddingBottom: "2rem",
        }}
      >
        <div className="l-retired-fund-selection">
          <div className="l-retired-fund-selection__wrapper">
            <BackButton
              handleBack={() => {
                dataLayerGTM(
                  "click_tag",
                  "Click",
                  "Button",
                  `Retirement Fund listing - back button`
                );

                history.push("/dashboard/Retirement");
              }}
              className="c-back-btn--small"
              title="Step 1 of 2"
            />
            <h1 className="l-retired-fund-selection__title">
              Funds is automatically assigned based on your year of birth.
              Please select either Conventional or Islamic.
            </h1>
          </div>
          <FundList
            funds={funds}
            currentTab="conservative"
            handleSelect={handleSelect}
            tabs={["conservative", "moderate", "aggressive"]}
            productType="retirement"
          />
        </div>
        <div className="l-retired-fund-selection__disclaimer">
          <span>
            We are committed to putting our clients first by delivering services
            that are guided by fairness, empathy, and a genuine understanding of
            clients’ needs. If you find yourself experiencing personal
            challenges or difficulties that may require further assistance,
            please let us know by visiting{" "}
            <span
              style={{ textDecoration: "underline", color: "blue" }}
              onClick={() => {
                window.my.navigateTo({
                  url:
                    "/pages/link/link?url=" +
                    encodeURIComponent("https://www.principal.com.my/en/vc"),
                });
              }}
            >
              www.principal.com.my/en/vc
            </span>
            .
            <br />
            <br />
            <h4>Disclaimer:</h4>
            <br />
            You may view the Fund Documents by clicking on ‘Fund Info’. Please
            note that past performance is not an indication of future
            performance.
            <br />
            The listed holdings are not a recommendation for buying or selling.
            Any application received after 12:00 p.m. will be processed on the
            next Business Day.
          </span>
        </div>
      </div>
    </>
  );
};

const withConnect = connect(
  state => ({
    funds: state.fundSelectionReducer.fundList,
    fundsLoading: state.fundSelectionReducer.fundListLoading,
    profile: state.goal.profile,
  }),
  {
    getFundList,
    sendFundsCode,
  }
);

export default compose(
  withRouter,
  withConnect
)(RetiredFundSelection);
